import styled from 'styled-components';
import {
  primaryColor,
  primaryColorDark,
  primaryColorLight,
  primaryColorStrong,
  disabledBackground,
  disabledText,
} from '../../config/colors';

export const ButtonWrapper = styled.button`
  border: 0px;
  padding: 0px;
  width: 100px;
  height: 45px;
  background-color: ${primaryColor};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  box-shadow: 0px 1px 15px rgb(0 0 0 / 20%);
  &:hover {
    opacity: 0.85;
    cursor: pointer;
  }
  &:active {
    background-color: ${primaryColorDark};
  }
  :disabled {
    background-color: ${disabledBackground};
    color: ${disabledText};
    cursor: not-allowed;
  }

  @media print {
    display: none;
  }
`;

export const ButtonText = styled.p`
  color: white;
  font-weight: 800;
  font-size: 0.9rem;
`;

export const ButtonRounded = styled(ButtonWrapper)`
  border-radius: 100px;
`;

export const LinkButton = styled.button`
  display: block;
  width: 100%;
  background-color: ${primaryColorStrong};
  color: white;
  cursor: pointer;
  border: 0;
  font-size: 0.938rem;
  font-weight: 500;
  padding: 12px 0 11px 0;
  margin: 0;
  :disabled {
    background-color: ${disabledBackground};
    color: ${disabledText};
    cursor: not-allowed;
  }
`;

export const TransparentBgButton = styled(ButtonWrapper)`
  width: 100%;
  background-color: transparent;
  box-shadow: none;
  &:hover {
    background-color: transparent;
    cursor: pointer;
  }
`;
